<template>
  <div>
    <error slot="description" :errors="errors"/>
    <success :success="success"/>

    <md-field class="md-form-group" slot="inputs" v-for="(input, key) in auth" :key="key">
      <md-icon>{{ input.icon }}</md-icon>
      <label>{{ input.label }}</label>
      <md-input v-model="input.value" :type="input.type" :disabled="input.disabled"></md-input>
    </md-field>
    <!--
Раскоментировать код ниже и в selectSystem: 'old' убрать old, решить с реактивность параметра "colorantSystem"
в компоненте Account и откоректировать бек
-->
<!--       <div class="position-relative">
        <md-field class="md-form-group" slot="inputs"  >
          <md-icon>color_lens</md-icon>
          <label style="top: -13px;">Система колеровки</label>
          <p class="m-2" style="margin-left: 13px !important;">{{user.data_machine.colorant_system}}</p>

        </md-field>


        <b-form-select  class="m-3 form-select w-50 position-absolute" v-model="selectSystem" style="top:-15px;left: 44%;">
          <b-form-select-option  v-for="item in colorantSystem" :value="item" :key="item">
            {{item}}</b-form-select-option>
        </b-form-select>
      </div>-->
    <md-button class="md-warning" @click="changeUser()">Изменить</md-button>
  </div>
</template>

<script>

import Error from "./Error";
import {mapActions} from "vuex";
import Success from "./Success";

export default {
  name: "User",
  components: {Success, Error},
  props: ['user'],
  data(){
    return {
      selectSystem: 'old',
      colorantSystem: ['old','new'],
      auth: {
        name: {
          label: 'Фамилия, Имя',
          value: '',
          type: 'text',
          icon: 'face',
          disabled: false
        },
        email: {
          label: 'Email адресс',
          value: '',
          type: 'email',
          icon: 'alternate_email',
          disabled: true
        },
        city: {
          label: 'Город',
          value: '',
          type: 'text',
          icon: 'place',
          disabled: true
        },
        address: {
          label: 'Адрес торговой точки',
          value: '',
          type: 'text',
          icon: 'store',
          disabled: true
        },
        phone: {
          label: 'Номер телефона',
          value: '',
          type: 'phone',
          icon: 'phone',
          disabled: true
        },
        login: {
          label: 'Логин для входа в систему',
          value: '',
          type: 'text',
          icon: 'account_circle',
          disabled: false
        },
      },
      errors: null,
      success: null
    }
  },
  methods: {
    ...mapActions(["account/changeUser"]),
    changeUser() {
      let login = this.auth.login.value;
      let name = this.auth.name.value;
      let system = this.selectSystem;
      this.$store.dispatch('account/changeUser', { login, name, system })
          .then((success) => {
            this.errors = null;
            this.success = [
              success
            ]
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    }
  },
  mounted() {
    this.auth.name.value = this.user.name
    this.auth.email.value = this.user.email
    this.auth.city.value = this.user.city
    this.auth.address.value = this.user.address
    this.auth.phone.value = this.user.phone
    this.auth.login.value = this.user.login
  }

}

</script>

<style scoped>

</style>